<section class="why-choose-us-section py-5">
    <div class="container-fluid px-lg-5">
        <div class="row g-5 justify-content-center mt-4">
            <div *ngFor="let f of features; let idx = index" class="col-lg-4 col-md-6 mt-5 mt-lg-5 animate-on-scroll fade-up" [ngClass]="'stagger-' + (idx + 1)">
                <div class="feature-card">
                    <!-- Overlapping Circle Icon -->
                    <div class="feature-icon-wrap">
                        <i [class]="f.icon"></i>
                    </div>
                    <!-- Card Body -->
                    <div class="feature-card-body">
                        <h3 class="feature-title">{{ f.title }}</h3>
                        <p class="feature-desc">{{ f.desc }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
